import { useLocation } from "react-router-dom";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getDetectLive } from "../api/detect";
import { GetDetectLiveParams } from "../types/types";
import userStorage from "../utils/userStorage";

const useGetDetectLive = ({
  mobility_code = -1,
  searchKey = "",
  area,
  page,
  limit,
  swlng,
  swlat,
  nelng,
  nelat,
  startDate,
  endDate,
  event_code,
  groupId,
  runStat,
  isDetect,
}: GetDetectLiveParams & { isDetect?: boolean }) => {
  const location = useLocation();
  const user = userStorage.get();

  const { data, isSuccess, isLoading, isError, isPlaceholderData, refetch } = useQuery({
    queryKey: isDetect
      ? ["Monitoring"]
      : [
          "DetectLive",
          `mobility_code: ${mobility_code}`,
          `searchKey: ${searchKey}`,
          `area: ${area}`,
          `page: ${page}`,
          `limit: ${limit}`,
          `swlng: ${swlng}`,
          `swlat: ${swlat}`,
          `nelng: ${nelng}`,
          `nelat: ${nelat}`,
          `startDate: ${startDate}`,
          `endDate: ${endDate}`,
          `event_code: ${event_code}`,
          `groupId: ${groupId}`,
          `runStat: ${runStat}`,
        ],
    queryFn: () =>
      getDetectLive({
        mobility_code,
        searchKey,
        area,
        page,
        limit,
        swlng,
        swlat,
        nelng,
        nelat,
        startDate,
        endDate,
        event_code,
        groupId,
        runStat,
      }),
    retry: false,
    enabled:
      location.pathname !== `/login` &&
      location.pathname !== `/maintenance` &&
      !!user,
    staleTime: 1000 * 10,
    refetchInterval: 1000 * 10,
    // 조회 조건(지도 범위 등)이 바뀌어도 이전 결과를 그대로 두고 뒤에서 새로 받는다.
    // 매번 빈 화면 + 전체 로딩 스피너가 뜨던 것을 막는다.
    placeholderData: keepPreviousData,
  });

  return { data, isSuccess, isLoading, isError, isPlaceholderData, refetch };
};

export default useGetDetectLive;
